<div class="modal fade show" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" *ngIf='item'> {{ 'meetings.EditAgendaItem' | translate }} </h4>
                <h4 class="modal-title" *ngIf='!item'> {{ 'meetings.AddAgendaItem' | translate }} </h4>

                <button type="button" class="close" aria-label="Close" (click)="closePop()">
                    <span>&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <form [formGroup]="formGroup">

                    <div class="form-group">
                        <mat-form-field>
                            <mat-label>{{ 'meetings.AgendaItemTitle' | translate }}</mat-label>
                            <input matInput formControlName="title" maxlength="250">

                            <mat-error *ngIf="formGroup.get('title').hasError('required')">
                                {{ 'tasks.requiredTitle' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- <div class="form-group" *ngIf='item'>
                        <mat-form-field>
                            <mat-label> {{ 'meetings.AgendaItemorde' | translate }}</mat-label>
                            <mat-select formControlName="itemOrder">
                                <mat-option *ngFor='let in of counter(item.itemsCount); let i = index;'
                                    [value]="i+1">{{i+1}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div> -->


                    <!-- is Case -->
                    <mat-slide-toggle class="block-slide-toggle mb-3" labelPosition="before" [(ngModel)]="isCase"
                        [ngModelOptions]="{standalone: true}" *ngIf="item?.canUploadPathologySlides">
                        {{ 'agendaCase.isCase' | translate }}
                    </mat-slide-toggle>

                    <div [hidden]="!isCase">
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>{{ 'agendaCase.mrn' | translate }}</mat-label>
                                <input matInput maxlength="250" formControlName="mrn" [required]="isCase">
                                <mat-error *ngIf="hasError('mrn', 'required')">
                                    {{ 'meetings.Required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>{{ 'agendaCase.National ID' | translate }}</mat-label>
                                <input matInput maxlength="250" formControlName="nationalId" [required]="isCase">
                                <mat-error *ngIf="hasError('nationalId', 'required')">
                                    {{ 'meetings.Required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>{{ 'agendaCase.pationtName' | translate }}</mat-label>
                                <input matInput maxlength="250" formControlName="pationtName" [required]="isCase">
                                <mat-error *ngIf="hasError('pationtName', 'required')">
                                    {{ 'meetings.Required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label> {{ 'agendaCase.dateOfBirth' | translate }}</mat-label>
                                <input matInput [max]="maxDate" [matDatepicker]="picker" readonly
                                    formControlName="dateOfBirth" [required]="isCase">
                                <mat-icon matDatepickerToggleIcon *ngIf="formGroup.controls['dateOfBirth'].value" (click)="formGroup.controls['dateOfBirth'].setValue('')">clear</mat-icon>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>

                                <mat-error *ngIf="hasError('dateOfBirth', 'required')">
                                    {{ 'meetings.Required' | translate }}
                                </mat-error>
                                <mat-error
                                    *ngIf="hasError('dateOfBirth', 'matDatepickerMin') || hasError('dateOfBirth', 'matDatepickerMax')">
                                    {{ 'messages.dateInvalid' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>{{ 'agendaCase.Gender' | translate }}</mat-label>
                                <mat-select formControlName="gender" [required]="isCase">
                                    <mat-option></mat-option>
                                    <mat-option *ngFor="let gender of genders" [value]="gender.id">
                                        {{ gender.name | translate }}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="hasError('gender', 'required')">
                                    {{ 'meetings.Required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>{{ 'agendaCase.Diagnosis' | translate }}</mat-label>
                                <mat-select formControlName="diagnosisId" [required]="isCase">
                                    <mat-option></mat-option>
                                    <mat-option *ngFor="let diagnosis of diagnosisList" [value]="diagnosis.id">
                                        <ng-container *ngIf="language == 'ar'">
                                            {{diagnosis.title_Ar}}
                                        </ng-container>
                                        <ng-container *ngIf="language == 'en'">
                                            {{diagnosis.title_En}}
                                        </ng-container>
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="hasError('diagnosisId', 'required')">
                                    {{ 'meetings.Required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-group">
                            <mat-form-field>
                                <mat-label>{{ 'agendaCase.Referred from' | translate }}</mat-label>
                                <mat-select formControlName="referredFromId" [required]="isCase">
                                    <mat-option></mat-option>
                                    <mat-option *ngFor="let referred of referredFromList" [value]="referred.id">
                                        <ng-container *ngIf="language == 'ar'">
                                            {{referred.title_Ar}}
                                        </ng-container>
                                        <ng-container *ngIf="language == 'en'">
                                            {{referred.title_En}}
                                        </ng-container>
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="hasError('referredFromId', 'required')">
                                    {{ 'meetings.Required' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- end is Case -->
                    <div class="form-group my-5">
                        <label class="mb-2">{{ 'meetings.Attachments' | translate }}</label>
                        <app-file-manager class="one-col" [files]='files' [maxFileSize]='25'
                            [allowedExt]="['PPTX', 'PPT', 'XLSX', 'PDF']" (deletedFilesList)='deletedFiles = $event'
                            (selectedFiles)="files = $event"></app-file-manager>
                    </div>

                    <div class="modal-btns">
                        <button type="reset" class="close closebtn" aria-label="Close" (click)="closePop()">
                            {{ 'meetings.DiscardChanges' | translate }}
                        </button>
                        <button mat-raised-button class="btn customBtn" (click)="saveItem()" [disabled]="loading"
                            [ngClass]="{ 'loading': loading }">
                            {{ 'meetings.Save' | translate }}
                        </button>
                    </div>

                </form>
            </div>
        </div>
    </div>
